// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_n2-5";
export var filledCircle = "_n2-4";
export var historyEntry = "_n2-3";
export var messageSideLeft = "_n2-1";
export var messageSideRight = "_n2-2";
export var orderTrackingCarouselWrapper = "_n2-6";
export var orderTrackingInfoContainer = "_n2-0";